import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Menu } from 'lucide-react'
import logo from '@/assets/logo.png'
import { AppSidebar } from './AppSidebar'
import { UserAvatarMenu } from '@/components/common/UserAvatarMenu'

export const AppLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <AppSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-gray-200 px-4 flex items-center justify-between h-[60px]">
          <button onClick={() => setSidebarOpen(true)} className="lg:hidden p-2 rounded-md hover:bg-gray-100">
            <Menu className="w-5 h-5" />
          </button>
          
          {/* Mobile view brand name */}
          <a href="https://hocnhe.com" className="lg:hidden flex items-center gap-2 text-left">
            <img src={logo} alt="Học Nhé" className="w-6 h-6 object-contain" />
            <div className="flex flex-col">
              <span className="text-[12px] font-black tracking-tight leading-none text-[#0068FF]">
                Học Nhé
              </span>
              <span className="text-[7.5px] text-[#E65F00] font-extrabold tracking-wider mt-0.5 uppercase">
                Học cùng nhau
              </span>
            </div>
          </a>

          {/* Desktop view brand name */}
          <div className="hidden lg:block text-slate-800 font-bold text-sm tracking-tight">
            Quản lý Học liệu Tiếng Anh
          </div>

          {/* Right Header controls */}
          <div className="flex items-center gap-3">
            <UserAvatarMenu />
          </div>
        </header>

        <main className="flex-1 px-4 py-5 sm:p-6 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
